import { IVehicle } from "interfaces/session/IVehicle";

export function getPayload(pageType: any, product: any, vehicle: IVehicle) {
  const {
    sku,
    partNumber,
    wasPrice,
    corePrice,
    price,
    manufacturer,
    description,
    category,
    productLines,
    enCategory,
    enDescription,
  } = product;

  const productLine = productLines && productLines.length > 0 ? productLines[0] : "";

  const {
    tier0, tier1, tier2, tier3,
  } = enCategory || category || {};
  return {
    pageType,
    sku,
    partNumber,
    wasPrice,
    corePrice,
    price,
    manufacturer,
    description: enDescription || description,
    tier0,
    tier1,
    tier2,
    tier3,
    fitment: vehicle,
    productLine,
  };
}
